import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import HttpBackend from 'i18next-http-backend'

// Bundle English directly — needed for instant first render and Terms/Privacy pages
import en from './locales/en/translation.json'

export const LANGUAGES = [
  { code: 'en', flag: '🇬🇧', name: 'English' },
  { code: 'ar', flag: '🇸🇦', name: 'العربية' },
  { code: 'bn', flag: '🇧🇩', name: 'বাংলা' },
  { code: 'cs', flag: '🇨🇿', name: 'Čeština' },
  { code: 'de', flag: '🇩🇪', name: 'Deutsch' },
  { code: 'el', flag: '🇬🇷', name: 'Ελληνικά' },
  { code: 'es', flag: '🇪🇸', name: 'Español' },
  { code: 'fa', flag: '🇮🇷', name: 'فارسی' },
  { code: 'fr', flag: '🇫🇷', name: 'Français' },
  { code: 'he', flag: '🇮🇱', name: 'עברית' },
  { code: 'hi', flag: '🇮🇳', name: 'हिन्दी' },
  { code: 'hu', flag: '🇭🇺', name: 'Magyar' },
  { code: 'id', flag: '🇮🇩', name: 'Indonesia' },
  { code: 'it', flag: '🇮🇹', name: 'Italiano' },
  { code: 'ja', flag: '🇯🇵', name: '日本語' },
  { code: 'ko', flag: '🇰🇷', name: '한국어' },
  { code: 'ms', flag: '🇲🇾', name: 'Melayu' },
  { code: 'nl', flag: '🇳🇱', name: 'Nederlands' },
  { code: 'pl', flag: '🇵🇱', name: 'Polski' },
  { code: 'pt', flag: '🇵🇹', name: 'Português' },
  { code: 'ro', flag: '🇷🇴', name: 'Română' },
  { code: 'ru', flag: '🇷🇺', name: 'Русский' },
  { code: 'sv', flag: '🇸🇪', name: 'Svenska' },
  { code: 'th', flag: '🇹🇭', name: 'ไทย' },
  { code: 'tl', flag: '🇵🇭', name: 'Filipino' },
  { code: 'tr', flag: '🇹🇷', name: 'Türkçe' },
  { code: 'uk', flag: '🇺🇦', name: 'Українська' },
  { code: 'ur', flag: '🇵🇰', name: 'اردو' },
  { code: 'vi', flag: '🇻🇳', name: 'Tiếng Việt' },
  { code: 'zh', flag: '🇨🇳', name: '中文' },
]

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      // Only English is bundled — other languages load on demand
      en: { translation: en },
    },
    backend: {
      loadPath: '/locales/{{lng}}/translation.json',
    },
    fallbackLng: 'en',
    // Don't load via backend if already bundled
    partialBundledLanguages: true,
    interpolation: { escapeValue: false },
  })

export default i18n
